// Order is load-bearing: the grid is three columns above 848px, so the first three
// entries are the top row, and the BTS "Explore Diffit" tour anchors its arrow to
// index 0 (see PromptLibraryInline.jsx).
export const PROMPT_LIBRARY_TEMPLATES = [
  {
    emoji: '📽️',
    label: 'Slides for direct instruction, with checks for understanding.',
    prompt: 'A slide deck to teach',
  },
  {
    emoji: '🧰',
    label: 'Lesson kit — mini lesson, guided notes, practice, and exit ticket together.',
    prompt: 'A mini lesson with guided notes, practice problems, and exit ticket for',
  },
  {
    emoji: '🧩',
    label: 'Station rotation with centers, recording sheets, and teacher directions.',
    prompt: 'A station rotation with 4 centers for',
  },
  {
    emoji: '📖',
    label: 'Reading passage with comprehension questions, adapted to your students.',
    prompt: 'A reading passage with comprehension questions about',
  },
  {
    emoji: '🎟️',
    label: 'Quick exit ticket to check understanding.',
    prompt: 'A 3-question exit ticket on',
  },
  {
    emoji: '🧮',
    label: 'Advanced math practice with multi-step problems and worked solutions.',
    prompt: 'Practice problems with multi-step problems and worked solutions for',
  },
  {
    emoji: '🔤',
    label: 'Decodable phonics reader aligned to the sounds your students are learning.',
    prompt: 'A decodable reader focusing on',
  },
  {
    emoji: '🖥️',
    label: 'Review slides with guided notes.',
    prompt: 'A review slide deck with guided notes for',
  },
  {
    emoji: '🧪',
    label: 'Chemistry practice with balanced equations, stoichiometry, and complex notation.',
    prompt: 'A chemistry worksheet with balanced equations and worked examples for',
  },
  {
    emoji: '📅',
    label: 'Multi-day lesson sequence with slides, activities, and assessment.',
    prompt: 'A 3-day lesson sequence with slides, activities, and assessment for',
  },
  {
    emoji: '📋',
    label: 'Task card set with answer key for centers, review, or early finishers.',
    prompt: 'A set of 20 task cards (full instructions on each card) with answer key for',
  },
  {
    emoji: '🔬',
    label: 'Science lab with hypothesis, data collection, and CER conclusion.',
    prompt: 'An inquiry lab with hypothesis, data table, and CER conclusion for',
  },
  {
    emoji: '🏆',
    label: 'Review game — quiz show, scavenger hunt, or challenge format.',
    prompt: 'A review game for',
  },
  {
    emoji: '🏛️',
    label: 'Document-based question with primary sources and essay prompt.',
    prompt: 'A document-based question using primary sources from the internet and essay prompt on',
  },
  {
    emoji: '📝',
    label: 'Writing activity with prompt, planning organizer, and rubric.',
    prompt: 'A writing activity with prompt, planning organizer, and rubric for',
  },
  {
    emoji: '🪜',
    label: 'Tiered practice at three difficulty levels with answer key.',
    prompt: 'A practice set at three difficulty levels with answer key for',
  },
  {
    emoji: '🎯',
    label: 'Choice board with nine activity options for students to show learning.',
    prompt: 'A choice board with 9 ways to show learning about',
  },
  {
    emoji: '🗣️',
    label: 'Slides for guided practice with discussion prompts.',
    prompt: 'A guided practice slide deck with discussion prompts for',
  },
  {
    emoji: '🤒',
    label: 'Full-day sub plans, print-and-go.',
    prompt: 'A full day of print-and-go substitute plans reviewing',
  },
  {
    emoji: '📊',
    label: 'Graphic organizer — Venn, cause-effect, flow chart, or whatever fits.',
    prompt: 'A graphic organizer for',
  },
  {
    emoji: '🛠️',
    label: 'Project-based activity with driving question, directions, and rubric.',
    prompt: 'A project-based activity with driving question, directions, and rubric for',
  },
  {
    emoji: '☀️',
    label: 'A week of bell ringers for focused daily review.',
    prompt: 'A week of daily warm-ups reviewing',
  },
  {
    emoji: '💬',
    label: 'Vocabulary activity with images and context clues practice.',
    prompt: 'A vocabulary activity with images and context clues practice for',
  },
  {
    emoji: '✅',
    label: 'Unit test with multiple choice, short answer, and extended response — with answer key.',
    prompt: 'A unit test with multiple choice, short answer, and an extended response question on',
  },
];
